import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
// TM-1000001721 — object detail components
import {
    EeExportTypeObjectComponent
} from "./component/object-components/ee-export-type-object-component/ee-export-type-object.component";
import {
    EeStructureObjectComponent
} from "./component/object-components/ee-structure-object-component/ee-structure-object.component";
import {
    EeExportObjectComponent
} from "./component/object-components/ee-export-object-component/ee-export-object.component";
// TM-1000001727: P8b — Object-Component fuer EeExportHookBinding
import {
    EeExportHookBindingObjectComponent
} from "./component/object-components/ee-export-hook-binding-object-component/ee-export-hook-binding-object.component";

export const EE_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            // TM-1000001721: complex entities with dedicated object pages
            ['ee.EeExportType', {
                route: '/ee/eeExportTypes',
                objectRoute: '/ee/exportType/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: EeExportTypeObjectComponent}]
            }],
            ['ee.EeStructure', {
                route: '/ee/eeStructures',
                objectRoute: '/ee/structure/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: EeStructureObjectComponent}]
            }],
            ['ee.EeStructureField', {route: '/ee/eeStructureFields'}],
            ['ee.EeExport', {
                route: '/ee/eeExports',
                objectRoute: '/ee/export/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: EeExportObjectComponent}]
            }],
            ['ee.EeExportRecord', {route: '/ee/eeExportRecords'}],
            ['ee.EeExportRecordStructure', {route: '/ee/eeExportRecordStructures'}],
            ['ee.EeExportRecordStructureField', {route: '/ee/eeExportRecordStructureFields'}],
            // TM-1000001727: P8a — neue Entities, P8b — objectRoute + Object-Component fuer EeExportHookBinding.
            // EeExportCheckpoint: @NonCrudEntity (interne Runtime-Daten) — kein objectRoute, keine Object-Page.
            ['ee.EeExportHookBinding', {
                route: '/ee/eeExportHookBindings',
                objectRoute: '/ee/exportHookBinding/:id',
                objectComponent: [{mode: MvsCrudModeEnum.update, component: EeExportHookBindingObjectComponent}]
            }],
            ['ee.EeExportCheckpoint', {route: '/ee/eeExportCheckpoints'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
